var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _PlayerCanvasComponent_player_accessor_storage;
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { imageName } from "../game/entity/player";
import { playerInfoToLayers } from "../game/player-info";
import { Aseprite } from "../lib/aseprite";
let PlayerCanvasComponent = class PlayerCanvasComponent extends LitElement {
    constructor() {
        super(...arguments);
        _PlayerCanvasComponent_player_accessor_storage.set(this, undefined);
    }
    get player() { return __classPrivateFieldGet(this, _PlayerCanvasComponent_player_accessor_storage, "f"); }
    set player(value) { __classPrivateFieldSet(this, _PlayerCanvasComponent_player_accessor_storage, value, "f"); }
    render() {
        const image = Aseprite.images[imageName];
        if (!image || !image.loadPromise) {
            return;
        }
        if (!image.loaded) {
            return;
        }
        const width = image.frames[0].sourceSize.w;
        const height = image.frames[0].sourceSize.h;
        return html `<canvas class="canvas" width="${width}" height="${height}"></canvas>`;
    }
    firstUpdated() {
        Aseprite.images[imageName].loadPromise.then(() => {
            this.requestUpdate();
        });
    }
    updated() {
        this.drawPlayer();
    }
    drawPlayer() {
        if (!this.player) {
            return;
        }
        const canvas = this.shadowRoot.querySelector("canvas");
        if (!canvas) {
            return;
        }
        const context = canvas.getContext("2d");
        context.clearRect(0, 0, canvas.width, canvas.height);
        Aseprite.drawAnimation({
            context,
            image: imageName,
            animationName: 'idle',
            time: 0,
            position: { x: 0, y: 0 },
            layers: playerInfoToLayers(this.player),
        });
    }
};
_PlayerCanvasComponent_player_accessor_storage = new WeakMap();
// Use pixelated scaling
PlayerCanvasComponent.styles = css `
        canvas {
            image-rendering: pixelated;
            width: 100%;
        }
    `;
__decorate([
    property({ type: Object })
], PlayerCanvasComponent.prototype, "player", null);
PlayerCanvasComponent = __decorate([
    customElement("player-canvas")
], PlayerCanvasComponent);
export { PlayerCanvasComponent };
